import { render, staticRenderFns } from "./CardRecommendation.vue?vue&type=template&id=60bb892e&scoped=true"
import script from "./CardRecommendation.vue?vue&type=script&lang=js"
export * from "./CardRecommendation.vue?vue&type=script&lang=js"
import style0 from "./CardRecommendation.vue?vue&type=style&index=0&id=60bb892e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb892e",
  null
  
)

export default component.exports